<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="template"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="verificationTempalteForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Template Listing"
          addButton="Tambah Template"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Template Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Template</h3>
          </div>

          <b-form id="verificationTempalteForm" validated novalidate>
            <b-row>
              <b-col sm="6">
                <b-form-group label-for="title" label="Title">
                  <b-form-input
                    id="title"
                    type="text"
                    v-model="$v.verificationTempalteForm.title.$model"
                    :state="!$v.verificationTempalteForm.title.$invalid"
                    required
                    placeholder="Title Template"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >Title harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group label-for="messages" label="Deskripsi">
                  <vue-editor
                    v-model="verificationTempalteForm.messages"
                    :editor-toolbar="customToolbar"
                    :state="!$v.verificationTempalteForm.messages.$invalid"
                  />
                  <b-form-invalid-feedback
                    v-if="!$v.verificationTempalteForm.messages.$invalid"
                    >Deskripsi harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="category" label="Template Untuk">
                  <model-select
                    id="category"
                    :options="listCategory"
                    v-model="$v.verificationTempalteForm.category.$model"
                    :isError="$v.verificationTempalteForm.category.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="verificationTempalteForm.category === null"
                    class="invalid-feedback-custom"
                  >
                    Kategori template harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="show" label="Flag">
                  <model-select
                    id="show"
                    :options="listStatus"
                    v-model="$v.verificationTempalteForm.show.$model"
                    :isError="$v.verificationTempalteForm.show.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="verificationTempalteForm.show === null"
                    class="invalid-feedback-custom"
                  >
                    Flag template harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="danger"
              @click="cancelAdd"
            >
              <i class="fa fa-undo"></i> Back </b-button
            >&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="saveProcess"
              :disabled="$v.verificationTempalteForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import { VueEditor, Quill } from "vue2-editor";

export default {
  name: "verification-template",
  components: { globalTable, ModelSelect, VueEditor, Quill },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      template: [],
      loading: true,
      listCategory: [
        {'value': '1', 'text': 'Penempatan Freezer'},
        {'value': '2', 'text': 'Pekerjaan Harian'}
      ],
      listStatus: [
        {'value': '1', 'text': 'Show'},
        {'value': '2', 'text': 'Hide'}
      ],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      fields: [
        { key: "title", label: "Title", class: "width-200", sortable: true },
        { key: "category_label", label: "Category", class: "width-200" },
        { key: "show_label", label: "Flag", class: "width-80" },
        { key: "messages", label: "Deskripsi" },
        { key: "action", class: "text-center width-80" },
      ],
      verificationTempalteForm: masterInterfaces.verification_template,
      isEdit: false,
    };
  },
  validations: {
    verificationTempalteForm: {
      title: { required },
      messages: { required },
      category: { required },
      show: { required }
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getTemplate();
    },
    getTemplate: function () {
      this.axios
        .get("web/master/verification-template/all/")
        .then((response) => {
          this.template = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.verificationTempalteForm = e;
    },
    resetForm: function () {
      for (var a in masterInterfaces.verification_template) {
        masterInterfaces.verification_template[a] = null;
      }
      this.verificationTempalteForm = masterInterfaces.verification_template;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah template ini?")) {
          this.axios
            .put(
              "web/master/verification-template/edit/",
              this.verificationTempalteForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Template Berhasil",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Ubah Template");
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan template ini?")) {
          this.axios
            .post(
              "web/master/verification-template/add/",
              this.verificationTempalteForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Template Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Template Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Tambah Template");
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

  